<template>
  <section id="shipment" class="page-content">
      <main id="section-body">
        <div class="columns is-variable is-8">
          <div class="shipment-detail column">
            <shipment-card v-if="shipment" :shipment="shipment" />
          </div>
          <div class="shipment-detail column is-four-fifths">
            <div class="card level">
                <div class="level-item has-text-centered">
                  <div>
                    <span class="ico" style="background: #1ca7d1"><icon icoClass='event-ico' selected='anchor'/></span>
                    <table><tr v-for="(group, gIndex) in ports_involved" :key="gIndex">
                      <td class="bold-title" v-for="(port, index) in group" :key="index" style="padding:0 3px">
                        {{port}},
                      </td>
                    </tr></table>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <a :href="map_url" target="_blank">
                      <span class="ico" style="background: #C03044"><icon icoClass='event-ico' selected='location'/></span>
                      <span class="bold-title" v-if="shipment.last_coordinates">{{shipment.last_coordinates.lat + ', ' + shipment.last_coordinates.lng}}</span>
                    </a>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <span class="ico" style="background: #E07020"><icon icoClass='event-ico' selected='date'/></span>
                    <span class="bold-title">
                      <table>
                        <tr><td>{{(shipment.ata ? 'ATA: ' : 'ETA: ') + (shipment.dta>0 ? '+' + shipment.dta : (shipment.dta==0 ? '-' : shipment.dta))}}</td></tr>
                        <tr><td>{{shipment.ata || shipment.eta ?
                          (shipment.ata ? shipment.ata : shipment.eta)
                          :
                          '' | toString}}</td></tr>
                      </table>
                    </span>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <span class="ico" style="background: #1c1761"><icon icoClass='event-ico' selected='shipments'/></span>
                    <table><tr v-for="(ship, index) in voyages_involved" :key="index">
                      <td class="bold-title" style="padding:0 3px">
                        {{ship.code + ' - ' + ship.vessel.name}}
                      </td>
                    </tr></table>
                  </div>
              </div>
            </div>
            <status-calendar :shipment="shipment" :planned="true"/>
            <status-calendar :shipment="shipment"/>
            <shipment-time-line v-if="shipment" :shipment="shipment" />
            <shipment-map :shipment="shipment"/>
            <a @click="back" class="button">Back</a>
          </div>

        </div>
      </main>
  </section>
</template>

<script>
import {mapActions} from 'vuex'
import ShipmentTimeLine from '@/components/ShipmentTimeLine'
import ShipmentCard from '@/components/ShipmentCard'
import ShipmentMap from '@/components/ShipmentMap'
import StatusCalendar from '@/components/StatusCalendar'
import icon from './../svg/events'
import moment from 'moment'

export default {
  name: 'shipment',
  components: {ShipmentTimeLine, ShipmentCard, StatusCalendar, ShipmentMap, icon},
  mounted () {
    this.$emit('loading')
    this.get(this.$route.params.id).then(
      response => {
        this.shipment = response
        this.$emit('loaded')
      }
    )
  },
  data () {
    return {
      shipment: {}
    }
  },
  filters: {
    toString: function (value) {
      if (value instanceof Date && !isNaN(value.valueOf())) {
        let dateString = moment(value).format('YYYY-MM-DD')
        return dateString
      }
      if (typeof (value) === 'object' && value) {
        return value.__str__
      }
      if (value) {
        return value.toString()
      }
      return ''
    }
  },
  computed: {
    map_url () {
      if (this.shipment['last_coordinates']) {
        var lastCoord = this.shipment['last_coordinates'].lat + ', ' + this.shipment['last_coordinates'].lng
        return `https://maps.google.com/?q=${lastCoord}&ll=${lastCoord}&z=5`
      }
      return null
    },
    ports_involved () {
      const portFields = ['pol', 'tsp1', 'tsp2', 'tsp3', 'tsp4', 'pod']
      let ports = []

      portFields.forEach(field => {
        if (this.shipment[`${field}_loc`] && this.shipment[`${field}_loc`].__str__) {
          ports.push(this.shipment[`${field}_loc`].__str__)
        }
      })
      ports = [ports.slice(0, ports.length / 2 + ports.length % 2), ports.slice(ports.length / 2 + ports.length % 2)]
      return ports
    },
    voyages_involved () {
      const voyageFields = ['leg1', 'leg2', 'leg3', 'leg4', 'leg5']
      let voyages = []

      voyageFields.forEach(field => {
        if (this.shipment[`${field}_voyage`]) {
          voyages.push({
            code: this.shipment[`${field}_voyage`],
            vessel: this.shipment[`${field}_vessel`]
          })
        }
      })
      return voyages
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    ...mapActions({
      get: 'shipment/retrieve'
    })
  }
}
</script>

<style lang="scss" scoped>
  #shipment #section-header {
    margin: 0;
    color: white;
    background: rgb(58, 63, 81);
    padding-left: 0;
    padding-right: 0;
    position: relative;
    top: 0;
    .title {
      color: white;
    }
  }
  .columns.is-variable.is-8 {
    --columnGap: 1rem;
  }
  .shipment-detail.column {
    padding-left: .5em;
    padding-right: .5em;
  }
  #shipment #section-body{
    padding-top: 30px;
  }
  ul.timeline, ul.timeline ul {
    list-style: disc;
    margin-left: 20px;
  }
  .ico {
    display: inline-block;
    border-radius: 50%;
    padding: 5px;
    margin: 10px;
  }
  .level {
    display: inline-block;
    padding: 1em;
  }
  .level-item {
    display: inline-block;
    font-size: 1.1em;
    padding: 0 1em;
  }
  table {
    display: inline-block;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PageShipment.vue